<template>
  <el-row class="excel_export">
    <el-col class="filter" :span="24">
      <label>时间范围</label>
      <el-date-picker
          v-model="dateRange" type="daterange" unlink-panels :clearable="false" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']">>
      </el-date-picker>
    </el-col>
    <el-col class="filter" :span="24">
      <label>病区范围</label>
      <el-select
          v-model="bedRange.selected"
          collapse-tags
          style="width: 350px"
          @change="getSelectedBed"
          placeholder="请选择病区">
        <el-option
            v-for="(item, index) in bedRange.total"
            :key="index"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
    </el-col>
    <el-col class="fileBtn">
      <label>表格导出</label>
      <el-button @click="getOrderListTable" style="width: 125px">订单明细表</el-button>
      <el-button @click="getSpuSalesTable">商品销量数据</el-button>
      <el-button @click="getSalesTable">商品销售详情</el-button>
      <el-button @click="getStockTable">当前库存信息统计表</el-button>
    </el-col>
    <!--  <el-col class="fileBtn">-->
    <!--    <label>表格导出</label>-->
    <!--    -->
    <!--  </el-col>-->
    <!--  <el-col class="fileBtn">-->
    <!--    <label>表格导出</label>-->
    <!--    -->
    <!--  </el-col>-->
  </el-row>
</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "ExcelExport",
  data() {
    return {
      GLOBAL,
      bedRange: {
        total: [],
        selected: '全部',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90 * 4);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateRange: [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
    }
  },
  created() {
    this.getBedInformation();
  },
  methods: {
    getSelectedBed() {
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.bedRange.selected);
      }
    },
    //床位信息
    getBedInformation() {
      this.$store.dispatch('Statistics/getBedInformation')
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.bedRange.total = res.data.data['病区号'];
            this.bedRange.total.unshift('全部');
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //订单
    getOrderListTable() {
      this.$store.dispatch('Statistics/getOrderListTable', {
        startTime: this.dateRange[0],
        endTime: this.dateRange[1],
        district: this.bedRange.selected,
      })
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            // 任务已创建
            this.$alert('导出任务已创建，请前往"导出任务管理"页面查看进度并下载文件', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push('/ExportTaskManagement');
              }
            });
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
            this.$message.error('创建导出任务失败');
          })
    },
    //商品销量
    getSpuSalesTable() {
      this.$store.dispatch("Statistics/getSpuSalesTable", {
        startTime: this.dateRange[0],
        endTime: this.dateRange[1],
        district: this.bedRange.selected,
      })
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            // 任务已创建
            this.$alert('导出任务已创建，请前往"导出任务管理"页面查看进度并下载文件', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push('/ExportTaskManagement');
              }
            });
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
            this.$message.error('创建导出任务失败');
          })
    },
    //  商品销售详情表
    getSalesTable() {
      this.$store.dispatch("Statistics/getSalesTable", {
        startTime: this.dateRange[0],
        endTime: this.dateRange[1],
        district: this.bedRange.selected,
      })
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            // 任务已创建
            this.$alert('导出任务已创建，请前往"导出任务管理"页面查看进度并下载文件', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push('/ExportTaskManagement');
              }
            });
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
            this.$message.error('创建导出任务失败');
          })
    },
    //  库存信息统计表
    getStockTable() {
      this.$store.dispatch("Statistics/getStockTable", {})
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            // 任务已创建
            this.$alert('导出任务已创建，请前往"导出任务管理"页面查看进度并下载文件', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push('/ExportTaskManagement');
              }
            });
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
            this.$message.error('创建导出任务失败');
          })
    }
  }
}
</script>

<style scoped>
.excel_export {
  padding: 10px;
}

.filter {
  text-align: left;
  padding: 10px;
  margin-bottom: 1rem !important;
}

label {
  margin-right: 1rem;
}

.fileBtn {
  text-align: left;
  margin-bottom: 1rem;
  padding: 10px;
}
</style>
